import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';


@Component({
  selector: 'app-payment-recharge',
  templateUrl: './payment-recharge.component.html',
  styleUrls: ['./payment-recharge.component.sass']
})
export class PaymentRechargeComponent implements OnInit {
  public subscriber;
  public selectBan;
  public token: string = sessionStorage.getItem("token");
  public prepaidBalance = JSON.parse(atob(sessionStorage.getItem("prepaidBalance")));
  public typePayment = [];
  public NameOnCard = "";
  public idNroTejeta = "";
  public cvNum = "";
  public prepaidPaymentAddress = [];
  public historial;
  public selectYear;
  public yearList = [];
  public year;
  public meses = [];
  public address;
  public fechaExp1 = '';
  public fechaExp2 = '';
  public zipcode = "";
  public idTransactionRecarga="";
  public dir = "";
  public dateTransaction = "";
  public allDate;
  public paymentMethodSelected = false;
  public idTransaction = "";
  public month = "";
  public yearSend = "";
  public tipoPago;
  public tipoTarjeta;
  public idTarjeta;
  public idCustomerCard=JSON.parse(atob(sessionStorage.getItem("idCustomerCard")));
  @Output() updateScreenView = new EventEmitter();
  @Output() updateIdTransactionRecarga = new EventEmitter();
  @Output() updateTotal = new EventEmitter();
  @Output() updateIdTransaction = new EventEmitter();
  @Output() updateInitializeData = new EventEmitter();
  @Input() totalPagar;
  @Input() idProduct;
  @Input() amount;
  constructor(private global: GlobalService, private loadingScreenService: LoadingScreenService, private services: Service) { }

  ngOnInit() {
    let fullDateNow = new Date();
    let actualDate = fullDateNow.getFullYear();
    let actualMonth: any = fullDateNow.getMonth() + 1;
    let actualDay: any = fullDateNow.getDate();
    let actualHour: any = fullDateNow.getHours();
    let minutes: any = fullDateNow.getMinutes();
    if (minutes.toString().length == 1) { minutes = "0" + minutes.toString(); }
    if (actualHour.toString().length == 1) { actualHour = "0" + actualHour.toString(); }
    if (actualDay.toString().length == 1) { actualDay = "0" + actualDay.toString(); }
    if (actualMonth.toString().length == 1) { actualMonth = "0" + actualMonth.toString(); }
    this.allDate = actualDate + "-" + actualMonth + "-" + actualDay + " " + actualHour + ":" + minutes;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.subscriber = this.global.getSuscriberByDefault(this.selectBan);
    this.paymentMethod();
    var meses1 = '[{"label":"","value":""},{"label":"01","value":"01"},{"label":"02","value":"02"},{"label":"03","value":"03"},{"label":"04","value":"04"},{"label":"05","value":"05"},{"label":"06","value":"06"},{"label":"07","value":"07"},{"label":"08","value":"08"},{"label":"09","value":"09"},{"label":"10","value":"10"},{"label":"11","value":"11"},{"label":"12","value":"12"}]';
    this.meses = JSON.parse(meses1);
    this.fechaExp1 = this.meses[0].value;
    var anios1 = '[{"label":"","value":""},{"label":"2019","value":"2019"},{"label":"2020","value":"2020"},{"label":"2021","value":"2021"},{"label":"2022","value":"2022"},{"label":"2023","value":"2023"},{"label":"2024","value":"2024"},{"label":"2025","value":"2025"},{"label":"2026","value":"2026"},{"label":"2027","value":"2027"},{"label":"2028","value":"2028"},{"label":"2029","value":"2029"},{"label":"2030","value":"2030"},{"label":"2031","value":"2031"},{"label":"2032","value":"2032"}]';
    this.yearList = JSON.parse(anios1);
    this.fechaExp2 = this.yearList[0].value;
  }
  continuePrepaidRecharge() {
    this.updateScreenView.emit(4);
  }
  cancelPrepaidRecharge() {
    this.updateScreenView.emit(1);
  }
  paymentMethod() {
    this.services.paymentMethod(this.token, this.subscriber).subscribe(data => {
      if (data.success == true) {
        this.typePayment = data.formPaymentTypes;
        sessionStorage.setItem("paymentMethod", btoa(JSON.stringify(data)));
        this.typePayment = JSON.parse(atob(sessionStorage.getItem("paymentMethod"))).formPaymentTypes;
        this.paymentAddress();
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.error);
      }
    });
  }
  paymentAddress() {
    this.services.paymentAddress(this.token, this.subscriber).subscribe(data => {
      if (data.success == true) {
        this.address = data.address;
        sessionStorage.setItem("paymentAddress", btoa(JSON.stringify(data)));
        this.prepaidPaymentAddress = JSON.parse(atob(sessionStorage.getItem("paymentAddress"))).address;
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.error);
      }
    });
  }
  updmonth(mes){
    if(this.global.validateSession()===true){
      if(mes.value=="10"||mes.value=="11"||mes.value=="12"){
        this.month=mes.value;
      }
      else{
        this.month=mes.value.substr(1);
      }
    }
  }
  updyear(anio){
    if(this.global.validateSession()===true){
      this.yearSend=anio.value;
    }
  }
  updcardValues(id,type,card){
    if(this.global.validateSession()===true){
      this.tipoPago=card;
      this.tipoTarjeta=type;
      this.idTarjeta=id;
    }
  }

  payRecharge() {
    if (this.global.validateSession() == true) {
      var total = 0;
      // var cardType = document.getElementsByName("card")
      var sw = false;
      if (this.paymentMethodSelected==true) {
        sw = true;
      }
      if (sw == true) {
        if (this.NameOnCard != "") {
          if (this.idNroTejeta != "") {
            if (this.fechaExp1 != "") {
              if (this.fechaExp2 != "") {
                if (this.cvNum != "" || this.tipoPago == 'DBT') {
                  if (this.zipcode != "") {
                    if (this.dir != "") {
                      if (this.tipoPago == 'DBT') {
                        this.loadingScreenService.startLoading();
                        total = this.twoDec(this.totalPagar);
                        this.services.payRechargeAth(this.token, this.dir, this.zipcode, total, this.NameOnCard, this.idNroTejeta, this.subscriber, this.month, this.yearSend, this.cvNum, this.idProduct, this.idTarjeta, this.idCustomerCard).subscribe(data => {
                          if (data.success == true) {
                            this.dateTransaction = this.allDate;
                            this.idTransaction = data.idTransaction;
                            this.services.sendRecharge(this.token, this.idProduct, this.amount.toFixed(2), this.idCustomerCard, this.subscriber).subscribe(data => {
                              if (data.success == true) {
                                  this.idTransactionRecarga = data.idTransaction;
                                  this.updateIdTransactionRecarga.emit(this.idTransactionRecarga);
                                  this.updateIdTransaction.emit(this.idTransaction);
                                  this.updateTotal.emit(total);
                                  this.updateInitializeData.emit();
                                  this.updateScreenView.emit(4);
                              }
                              else {
                                this.loadingScreenService.stopLoading();
                                this.global.notif(data.error);
                              }
                            });
                          }
                          else {
                            this.loadingScreenService.stopLoading();
                            this.global.notif(data.error);
                          }
                        });
                      }
                      else {
                        this.loadingScreenService.startLoading();
                        total = this.twoDec(this.totalPagar);
                        this.services.payRecharge(this.token,this.dir,this.zipcode,total,this.NameOnCard,this.idNroTejeta,this.subscriber,this.month,this.yearSend,this.cvNum,this.idProduct,this.idTarjeta,this.idCustomerCard).subscribe(data => {
                          if (data.success == true) {
                            this.dateTransaction = this.allDate;
                            this.idTransaction = data.idTransaction;
                            this.services.sendRecharge(this.token, this.idProduct,this.amount.toFixed(2), this.idCustomerCard, this.subscriber).subscribe(data => {
                              if (data.success==true) {
                                  this.idTransactionRecarga = data.idTransaction;
                                  this.updateIdTransactionRecarga.emit(this.idTransactionRecarga);
                                  this.updateIdTransaction.emit(this.idTransaction);
                                  this.updateTotal.emit(total);
                                  this.updateInitializeData.emit();
                                  this.updateScreenView.emit(4);
                              }
                              else {
                                this.loadingScreenService.stopLoading();
                                this.global.notif(data.error);
                              }
                            });
                          }
                          else {
                            this.loadingScreenService.stopLoading();
                            this.global.notif(data.error);
                          }
                        });
                      }
                    }
                    else {
                      this.global.notif("Debe selecionar la dirección de la Tarjeta.");
                    }
                  }
                  else {
                    this.global.notif("Debe colocar el código postal.");
                  }
                }
                else {
                  this.global.notif("Debe colocar el código de seguridad.");
                }
              }
              else {
                this.global.notif("Debe seleccionar la fecha de expiración.");
              }
            }
            else {
              this.global.notif("Debe seleccionar la fecha de expiración.");
            }

          }
          else {
            this.global.notif("Debe colocar el número de la tarjeta.");
          }
        }
        else {
          this.global.notif("Debe colocar el nombre y el apellido.");
        }
      }
      else {
        this.global.notif("Por favor seleccione un método de pago.");
      }
    }
  }
  back() {
    if (this.global.validateSession() == true) {
      this.updateScreenView.emit(1);
    }
  }
  twoDec(num) {
    num = Math.round(num * 100) / 100;
    return num;
  }
  changeTypePayment(type) {
    this.paymentMethodSelected = true;
    if (this.global.validateSession() == true) {
      if (type == 'ATH') {
        document.getElementById("idCodeCVV").style.display = "none";
      }
      else {
        document.getElementById("idCodeCVV").style.display = "block";
      }
    }
  }
  optionDir(index, dir, zipcode) {
    if (this.global.validateSession() == true) {
      for (var i = 0; i < this.prepaidPaymentAddress.length; i++) {
        document.getElementById("optionDir_" + i).className = "mnts-rcrg2";
      }
      const check = document.getElementById("checkDir_" + index) as HTMLInputElement;
      check.checked = true;
      this.dir = dir;
      document.getElementById("optionDir_" + index).className = "mnts-rcrg2 on";
    }
  }
}
